import useMountEffect from '@restart/hooks/useMountEffect';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useRef } from 'react';

import styles from './Heartbeat.module.scss';

import { getCSSVariable } from '@/utils/theme';

const cx = classNames.bind(styles);

const Heartbeat = ({ heartbeat }) => {
  const canvasRef = useRef();
  const dataArrayRef = useRef(Array(200).fill(null)); // 데이터 배열 (충분히 큼)
  const heartbeatPosRef = useRef(-1); // heartbeat 시작 위치
  const prevHeartbeatRef = useRef();
  const frameCounterRef = useRef(0); // 프레임 카운터

  useMountEffect(() => {
    // 초기 데이터를 centerY(가운데)로 초기화
    const centerY = 10; // canvas height(20) / 2
    dataArrayRef.current = Array(200).fill(centerY);

    const intervalId = setInterval(() => {
      drawWave();
    }, 16); // 약 60fps

    return () => {
      clearInterval(intervalId);
    };
  });

  useUpdateEffect(() => {
    if (heartbeat !== prevHeartbeatRef.current) {
      // heartbeat 신호 오면 화면 우측 끝에 새로운 파형 추가 (80 - 6)
      heartbeatPosRef.current = 74;
      prevHeartbeatRef.current = heartbeat;
    }
  }, [heartbeat]);

  const drawWave = () => {
    if (!canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;
    const centerY = height / 2;
    const amplitude = height / 3;
    const data = dataArrayRef.current;

    // heartbeat 신호가 올 때 파형 데이터 추가 (6개 포인트로 덜 자세하게)
    if (heartbeatPosRef.current >= 0 && heartbeatPosRef.current < data.length) {
      for (let i = 0; i < 6; i++) {
        const pos = heartbeatPosRef.current + i;
        if (pos < data.length) {
          const phase = (i / 6) * (2 * Math.PI);
          data[pos] = centerY + amplitude * Math.sin(phase);
        }
      }
      heartbeatPosRef.current = -1; // 한 번만 추가
    }

    // 4프레임마다 한 번씩 배열 이동 (80px를 5초에 흘러가게)
    frameCounterRef.current += 1;
    if (frameCounterRef.current >= 4) {
      frameCounterRef.current = 0;
      data.shift();
      data.push(centerY);
    }

    // 배경 지우기
    ctx.clearRect(0, 0, width, height);

    ctx.strokeStyle = getCSSVariable('--tint-color');
    ctx.lineWidth = 2;
    ctx.beginPath();

    // 화면에 표시할 범위 (처음 80px) 그리기
    for (let x = 0; x < width && x < data.length; x++) {
      const y = data[x];

      if (x === 0) {
        ctx.moveTo(x, y);
      } else {
        ctx.lineTo(x, y);
      }
    }

    ctx.stroke();
  };

  return (
    <div className={cx('container')}>
      <canvas ref={canvasRef} width={80} height={20} />
    </div>
  );
};

export default Heartbeat;
